(function () {
  const root = document.documentElement;

  if (root.dataset.smoothMotionInitialized === 'true') return;
  root.dataset.smoothMotionInitialized = 'true';

  const targetSelectors = [
    '.hero__content-wrapper',
    '.section-content-wrapper',
    '.hero__container',
    '.main-page__content',
    '.main-blog-post__content',
    '.main-contact__content',
    '.main-404__content',
    '.search-page__header',
    '.cart-page',
    '.product-information',
    '.product-grid-container',
    '.utilities',
    '.announcement-bar',
    '.spacing-style',
  ];

  const motionOffsets = new Map([
    ['.hero__content-wrapper', 2],
    ['.section-content-wrapper', 2],
    ['.hero__container', 2],
    ['.main-page__content', 2],
    ['.main-blog-post__content', 2],
    ['.main-contact__content', 2],
    ['.main-404__content', 2],
    ['.search-page__header', 1],
    ['.cart-page', 1],
    ['.product-information', 2],
    ['.product-grid-container', 1],
    ['.utilities', 1],
    ['.announcement-bar', 1],
    ['.spacing-style', 1],
  ]);

  const hasObserver = typeof IntersectionObserver === 'function';
  const observer = hasObserver
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const target = /** @type {HTMLElement} */ (entry.target);
            target.dataset.smoothMotionInView = 'true';
            observer.unobserve(target);
          });
        },
        {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.15,
        }
      )
    : null;

  const seen = new WeakSet();

  function shouldSkip(target) {
    return Boolean(
      target.closest('#header-group, .header-section, .philosophy-motion, .philosophy-section, [data-smooth-motion-skip]')
    );
  }

  function getMotionDistance(target, selector) {
    const baseDistance = motionOffsets.get(selector) ?? 16;
    const depth = Math.min(Math.max(target.querySelectorAll(':scope > *').length, 0), 3);
    return Math.min(baseDistance + depth, 4);
  }

  function registerTarget(target, selector) {
    if (!(target instanceof HTMLElement) || seen.has(target) || shouldSkip(target)) return;

    seen.add(target);
    target.dataset.smoothMotionTarget = 'true';
    target.style.setProperty('--smooth-motion-distance', `${getMotionDistance(target, selector)}px`);

    if (typeof target.getBoundingClientRect !== 'function') return;

    const rect = target.getBoundingClientRect();
    const isInInitialView = rect.top < window.innerHeight && rect.bottom > 0;

    if (isInInitialView) {
      target.dataset.smoothMotionInView = 'true';
      return;
    }

    if (!observer) {
      target.dataset.smoothMotionInView = 'true';
      return;
    }

    observer.observe(target);
  }

  function findTarget(section) {
    for (const selector of targetSelectors) {
      const target = section.querySelector(selector);
      if (!target) continue;

      if (target.closest('.header-section, #header-group')) continue;
      return { target, selector };
    }

    return null;
  }

  function registerAll() {
    document.querySelectorAll('main > .shopify-section, #footer-group > .shopify-section').forEach((section) => {
      const match = findTarget(section);
      if (match) registerTarget(match.target, match.selector);
    });
  }

  registerAll();

  document.addEventListener('shopify:section:load', registerAll);
  document.addEventListener('shopify:section:reorder', registerAll);
  document.addEventListener('shopify:section:unload', registerAll);
})();
